import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';

import { PresubscriptionsByAgeCategoryResolver } from './presubscriptions-by-age-category.resolver';
import { PresubscriptionsByCityResolver } from './presubscriptions-by-city.resolver';
import { PresubscriptionsByExperienceResolver } from './presubscriptions-by-experience.resolver';
import { PresubscriptionsByStatusResolver } from './presubscriptions-by-status.resolver';
import { StatsLabelService } from './stats-label-service';
import { StatsResourceService } from './stats-resource.service';
import { ApiResourceModule } from '../api-resource/api-resource.module';

@NgModule({
  declarations: [],
  exports: [],
  imports: [CommonModule, ApiResourceModule],
  providers: [
    StatsResourceService,
    PresubscriptionsByCityResolver,
    PresubscriptionsByExperienceResolver,
    PresubscriptionsByAgeCategoryResolver,
    PresubscriptionsByStatusResolver,
    StatsLabelService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class StatsResourceModule {}
